import { Component, OnInit, NgZone } from '@angular/core';
import { AlertController, PopoverController } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { TerminosComponent } from '../terminos/terminos/terminos.component';
import { PoliticasComponent } from '../politicas/politicas/politicas.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { httpGetIP } from 'src/app/util/location.utils';
import { IpService } from 'src/app/servicios/ipaddres/ip.service';
import { LINKS_WASAP, PRECIOS_ENVIO } from 'src/constant/constantes';
import { PedidoService } from 'src/app/servicios/pedido/pedido.service';
import { Router } from '@angular/router';
declare var Culqi: any;
import * as firebase from 'firebase';
import { DepartamentosService } from 'src/app/services/departamentos.service';

@Component({
  selector: 'app-pago',
  templateUrl: './pago.component.html',
  styleUrls: ['./pago.component.scss'],
})

export class PagoComponent implements OnInit {
  captchaPassed: boolean = false;
  captchaResponse: string;

  myDate: String = new Date().toISOString();
  minTime = '09:30';
  maxTime = '18:00';
  hourValues = ['06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'];
  minuteValues = ['00', '30'];
  minDate: string;
  maxDate: string;
  distritoDestino: any;

  form!: FormGroup;

  phoneNumber = {
    dialCode: '+51',
    internationalNumber: '12345678',
    isoCode: 'pe',
    nationalNumber: ''
  };
  phoneNumberReceptor = {
    dialCode: '+51',
    internationalNumber: '12345678',
    isoCode: 'pe',
    nationalNumber: ''
  };
  precio;
  tipoDocumentos: string[] = ['DNI', 'CE'];
  distritos = PRECIOS_ENVIO;
  departamentosSelect: any;
  proovinciasSelect: any;
  distritosSelect: any;
  protected LocalIP?: string;
  private function: any; 
  constructor(public alertCtrl: AlertController, public poper: PopoverController,
    public popoverController: PopoverController,
    private http: HttpClient, private zone: NgZone,
    private ipService: IpService,
    private formBuilder: FormBuilder,
    //public navParams: NavParams,
    public pedidoService: PedidoService,
    private router: Router,
    private departamentosService: DepartamentosService
  ) {
    this.function = firebase.functions();
    this.precio = "30";//this.navParams.get('precio');
    this.Fechamin = this.FormatoFechaMax();
    this.form = this.formBuilder.group({
      razonsocial: ['', [Validators.required]],
      recibo: ['boleta', [Validators.required]],
      numdocumento: ["", [Validators.required, Validators.pattern("[0-9]*")]],
      direccion: [''],
      telefono: ["", [Validators.required]],
      nombreReceptor: ["", [Validators.required]],
      direccionReceptor: ["", [Validators.required]],
      telefonoReceptor: ["", [Validators.required]],
      tipoDocu: ["DNI", [Validators.required]],
      //horaEngrega: ["", [Validators.required]],
      chekAccept: [false, [Validators.requiredTrue]],
      fechaEngrega: ["", [Validators.required]],
      distritoEngrega: ["", [Validators.required]],
      tipopago: ['normal', [Validators.required]],
      departamentoSelect: ["", [Validators.required]],
      proovinciasSelect: ["", [Validators.required]],
      distritoSelect: ["", [Validators.required]],
      provinciaSelect: ["", [Validators.required]]
    });

    httpGetIP.then((data) => this.LocalIP = String(data));

    const today = new Date();

    // Día actual + 1
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    // Si estamos en diciembre, permitir hasta febrero del próximo año
    let maxYear = today.getFullYear();
    let maxMonth = 11; // diciembre
    let maxDay = 31;

    if (today.getMonth() === 11) { // diciembre
      maxYear = today.getFullYear() + 1;
      maxMonth = 1; // febrero
      maxDay = this.isLeapYear(maxYear) ? 29 : 28;
    }

    const maxDateObj = new Date(maxYear, maxMonth, maxDay);

    // Convertir a formato ISO (YYYY-MM-DD)
    this.minDate = tomorrow.toISOString().split('T')[0];
    this.maxDate = maxDateObj.toISOString().split('T')[0];
  }

  ngOnInit() {
    this.pedidoService.getDistritos().then((distritos) => {
      this.distritos = distritos;
    });

    // Escuchar el token emitido desde index.html
    window.addEventListener('culqi-token', (event: any) => {
      const token = event.detail;
      this.procesarPago(token);
    });
  this.departamentosSelect = this.departamentosService.departamentos;
  }

  Fechamin;
  tiempoEntrega = 2;
  public FormatoFechaMax() {
    let date = new Date();
    date.setDate(date.getDate() + this.tiempoEntrega);
    let anio = date.getFullYear().toString();
    let mes = ("0" + (date.getMonth() + 1)).slice(-2)
    let dia = ("0" + date.getDate()).slice(-2);
    let hora = date.getHours().toString();
    let min = date.getMinutes().toString();
    return anio + "-" + mes + "-" + dia
  }
  async AlertaEliminar() {
    let ok = "Ok";
    const alert = await this.alertCtrl.create({
      header: "¡Gracias!",
      subHeader: "Nos pondremos en contacto contigo y te emviaremos un link de pago",
      buttons: [
        {
          text: "Si",
          handler: data => console.log("aceptar"),
          role: '',
        },
      ]
    });
    await alert.present();
  }

  activarBoton() {
    if (this.nombresComprador && this.comprobante && this.documentoComprador && this.direccionComprador && this.telefonoComprador && this.nombreReceptor && this.direccionReceptor && this.fechadeEntrega/* && this.captchaPassed*/) {
      this.botonlogin = false;
    } else {
      this.botonlogin = true;
    }
  }
  comprobante = "boleta";
  recibo(event) {
    let radio = event.detail.value;
    this.comprobante = radio;
    if (radio == "factura") {
      this.tipoDocumentos = ['RUC'];
    } else {
      this.tipoDocumentos = ['DNI', 'CE'];
    }
  }

  nombresComprador;
  nombres(event) {
    this.nombresComprador = event.detail.value;
    this.activarBoton();
  }

  documentoComprador;
  documentos(event) {
    this.documentoComprador = event.detail.value;
    this.activarBoton();
  }

  direccionComprador;
  direccion(event) {
    this.direccionComprador = event.detail.value;
    this.activarBoton();
  }

  telefonoComprador;
  telefono(event) {
    this.telefonoComprador = event.detail.value;
    this.activarBoton();
  }

  correoComprador;
  correo(event) {
    this.correoComprador = event.detail.value;
    this.activarBoton();
  }

  nombreReceptor;
  nombreRecepcion(event) {
    this.nombreReceptor = event.detail.value;
    this.activarBoton();
  }

  direccionReceptor;
  direccionRecepcion(event) {
    this.direccionReceptor = event.detail.value;
    this.activarBoton();
  }

  telefonoReceptor;
  telefonoRecepcion(event) {
    this.telefonoReceptor = event.detail.value;
  }

  fechadeEntrega;
  fechaEntrega(event) {
    this.fechadeEntrega = event.detail.value;
    this.activarBoton();
  }

  horaEntre;
  horaEntrega(event) {
    this.horaEntre = event.detail.value;
  }

  emailReceptor;
  correoRecepcion(event) {
    this.emailReceptor = event.detail.value;
  }

  changeDate(event: FocusEvent) {
    const eventTarget = event.target;
  }

  enviarPedido(transaction: any) {
    let data = this.form.getRawValue();
    let json = {
      ipLocal: this.LocalIP,
      mapIp: this.ipService.getMac(),
      diaPedido: this.FormatoFecha(),
      status: 'A',
      cliente: data.razonsocial,//this.nombresComprador,
      recibo: data.recibo,//this.comprobante, 
      numedoDoc: data.numdocumento,//this.documentoComprador,
      direccionComprador: data.direccion,//this.direccionComprador,
      telefonoComprador: data.telefono,//this.telefonoComprador,
      nombreRecepcion: data.nombreReceptor,//this.nombreReceptor,
      direccionReceptor: data.direccionReceptor,//this.direccionReceptor,
      telefonoReceptor: data.telefonoReceptor,//this.telefonoReceptor,
      //fechaEntrega: data.fechaEngrega,//this.fechadeEntrega, 
      //horaEntrega: data.horaEngrega,//this.horaEntre,
      precio: this.precio,
      transaction: transaction
    }
    this.poper.dismiss({
      pedido: json
    });
  }

  botonlogin = true;

  validarEmail() {
    this.form.markAllAsTouched()
    if (this.form.valid) {
      this.pagar();
    } else {
      this.Alerta2()
    }
  }

  async Alerta() {
    let ok = "Ok";
    const alert = await this.alertCtrl.create({
      header: "¡Cuidado!",
      subHeader: "Tú correo ingresado no es válido",
      buttons: [
        {
          text: "Entiendo",
          handler: data => console.log("aceptar"),
          role: '',
        },
      ]
    });
    await alert.present();
  }

  async Alerta2() {
    let ok = "Ok";
    const alert = await this.alertCtrl.create({
      header: "Faltan Datos",
      subHeader: "Faltan algunos campos obligatorios",
      buttons: [
        {
          text: "Entiendo",
          handler: data => console.log("aceptar"),
          role: '',
        },
      ]
    });
    await alert.present();
  }
  public FormatoFecha() {
    let date = new Date();
    let anio = date.getFullYear().toString();
    let mes = ("0" + (date.getMonth() + 1)).slice(-2)
    let dia = ("0" + date.getDate()).slice(-2);
    let hora = date.getHours().toString();
    let min = date.getMinutes().toString();
    return dia + "-" + mes + "-" + anio
  }



  captchaResolved(response: string): void {

    this.zone.run(() => {
      this.captchaPassed = true;
      this.captchaResponse = response;
    });

  }

  sendForm(): void {

    let data = {
      captchaResponse: this.captchaResponse
    };
  }

  ventaDetallada() {
    window.open(LINKS_WASAP.formularioPago);
  }

  terminosCondiciones() {
    this.router.navigate(['/terminos']);
    this.cerarPopOver();
  }

  //terminos condociones y politicas
  async verTerminos() {
    const popover = await this.popoverController.create({
      component: TerminosComponent,
      animated: true,
      translucent: true,
    });

    popover.onDidDismiss().then((data => { }))
    popover.dismiss().then((data => { }))
    return await popover.present();
  }

  async verPoliticas() {
    const popover = await this.popoverController.create({
      component: PoliticasComponent,
      animated: true,
      translucent: true,
    });

    popover.onDidDismiss().then((data => { }))
    popover.dismiss().then((data => { }))
    return await popover.present();
  }
  async cerarPopOver() {
    this.poper.dismiss();
  }

  onDateSelected(event: any) {
    const selectedDate = new Date(event.detail.value);

    console.log('✅ Fecha válida seleccionada:', selectedDate.toISOString().split('T')[0]);
  }

  // Método auxiliar para años bisiestos
  private isLeapYear(year: number): boolean {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  }

  distritoEntrega(event) {
    let distrito = event.detail.value;
    console.log("distrito", distrito);
    this.distritoDestino = distrito;
    //this.precio = Number(this.navParams.get('precio')) + Number(distrito.precio);
    this.precio.toFixed(2);
    this.form.patchValue({ distritoEngrega: distrito });
  }

  listProvincias: any;
  listDistritos: any;
  departamentoSelect(event){
    this.form.controls['provinciaSelect'].reset();
    this.form.controls['distritoSelect'].reset();
    this.listProvincias = event.detail.value.provincias;
  }
  
  provinciaSelect(event){
    this.form.controls['distritoSelect'].reset();
    this.listDistritos = event.detail.value.distritos;
  }
  
  distritoSelect(event){
    console.log(event)
    this.distritosSelect = event.detail.value;
  }

  pagar() {
  if (typeof Culqi === 'undefined') {
    console.error('Culqi no está definido. Verifica que el script esté en index.html');
    return;
  }

  Culqi.publicKey = 'pk_live_48FPofixDMyhiDNo';
  Culqi.settings({
    title: 'Caja Peluche S.A.C.',
    currency: 'PEN',
    amount: (Number(this.precio) * 100).toFixed(2),
    description: 'Compra de peluche personalizado.'
  });
  Culqi.open();
}

procesarPago(token: string) {
  const callable = this.function.httpsCallable('crearCargo');
  callable({ token })
    .then((res: any) => {
      console.log("res culqi: ", res)
      if (res.data.success) {                
        this.enviarPedido(res.data);
        this.pedidoService.mostrarToast("Compra exitosa", "success")
      } else {
        this.pedidoService.AlertCompra("Error en el pago, varifica los datos ingresados.", res.data.error)
      }
    })
    .catch((err: any) => {
      console.error('Error llamando función:', err);
      alert('Hubo un problema con el pago');
    });
}

}
